<template>
    <div class="departure">
        <div class="departureHead displayFlex">
            <div class="speedContet">
                <div
                    class="departureHead-right displayFlex justifyContent"
                    v-for="(item, index) in items"
                    :key="index"
                    v-show="hide"
                    :style="index===items.length-1?'width:'+(100/(items.length*2-1))+'%':'width:'+(200/(items.length*2-1))+'%'"
                >
                    <div class="circular flex1" :style="index===items.length-1?'100%':'50%'">
                        <div class="circular-img">
                            <h3>{{item.value}}</h3>
                            <div
                                class="circular-left textAlign"
                                :class="item.id ==='1' ?'active':'notActive'"
                            >{{item.titleName.trim ? item.titleName : item.titleName[item.id]}}</div>
                            <div class="circular-right">
                                <!-- <div
                                    :title="item.carName.trim ? item.carName : item.carName[item.id]"
                                    class="astern"
                                >{{item.carName.trim ? item.carName : item.carName[item.id]}}</div>-->
                                <div class="carTimes">{{item.carTimes}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="point" style="width:50%">
                        <div class="dashed">
                            <div class="dashe-lists" :class="items[index+1]&&items[index+1].id === '1'? 'dashe-lists' : 'arrowColor'"></div>
                            <div class="dashe-lists" :class="items[index+1]&&items[index+1].id === '1'? 'dashe-lists' : 'arrowColor'"></div>
                            <div class="dashe-lists" :class="items[index+1]&&items[index+1].id === '1'? 'dashe-lists' : 'arrowColor'"></div>
                            <div class="dashe-lists" :class="items[index+1]&&items[index+1].id === '1'? 'dashe-lists' : 'arrowColor'"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            visible: false
        };
    },
    props: {
        process: {
            type: Object
        },
        hide: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        items() {
            return (this.process && this.process.step instanceof Array) ? this.process.step : [];
        }
    }
};
</script>

<style lang="less">
.green {
    background: #5eb400;
}
.gray {
    background: #999;
}
.blue {
    background: blue;
}
.departure {
    width: 100%;
    // padding: 0 200px;
    display: inline-block;
    .displayFlex {
        display: flex;
    }
    .justifyContent {
        justify-content: center;
        align-items: center;
    }

    .flexDirection {
        flex-direction: column;
    }

    .textAlign {
        text-align: center;
    }
    font-size: 14px;
    background: #fff;
    border-radius: 4px;
    .departureHead {
        align-items: stretch;
         width: 100%;
    }
    .departureHead .speedContet {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .departureHead .departureHead-right .circular-img {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .departureHead .departureHead-right {
        .point {
            margin: auto;
            text-align: center;
        }
        .point .dashed .dashe-lists {
            width: 8px;
            height: 8px;
            background-color: #00cc61;
            opacity: 0.5;
            display: inline-block;
            margin: 0 6px;
            border-radius: 2px;
        }
        .point .dashed .arrowColor {
            width: 8px;
            height: 8px;
            background-color: #ccc;
            opacity: 0.5;
            display: inline-block;
            margin: 0 6px;
            border-radius: 2px;
        }
        &:last-child .point {
            display: none;
        }
    }
    .circular .circular-left {
        margin: 8px auto;
        width: 80px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
    }
    .circular .colorBlue {
        opacity: 0.5;
    }
    .circular .colorGray {
        opacity: 0.5;
    }
    .circular .circular-right {
        margin: 0 8px 0 16px;
    }
    .circular .circular-right .astern {
        margin-bottom: 4px;
        text-align: center;
        width: 240px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .circular .circular-right .carTimes {
        color: #999;
        text-align: center;
        height: 16px;
    }
    .active {
        background-color: #00cc61;
        color: #fff;
        border-radius: 2px;
    }
    .notActive {
        background-color: #fff;
        color: #999;
    }
}
</style>